
export const GEOCODER_ERROR_MSG = '町・字名不明';
